module.exports = __webpack_public_path__ + "media/application/images/svgs/hard-drive-43e87abeef27d010bbfa73117adb55b3.svg";